import { useNavigate } from 'react-router-dom'
import { useClipQueue } from '../lib/clipQueue'

/**
 * The clip being prepared, wherever you happen to be.
 *
 * Sits with the mini player, above the tab bar, for the same reason: work that
 * outlives the screen it started on needs somewhere to live that navigation
 * can't unmount. Shows the poster so it is obvious which clip is in flight.
 */
export default function ClipStatus() {
  const { job, cancel, dismiss } = useClipQueue()
  const nav = useNavigate()
  if (!job) return null

  const { phase, pct, eta, poster, title, error } = job
  const overall = phase === 'preparing' ? pct * 0.8
    : phase === 'posting' ? 80 + pct * 0.2
    : 100

  const countdown = eta === null || eta === undefined ? null
    : eta > 150 ? 'a couple of minutes'
    : eta > 75 ? 'about a minute and a half'
    : eta > 45 ? 'about a minute left'
    : eta > 8 ? `about ${Math.round(eta / 5) * 5}s left`
    : 'nearly there'

  const line = phase === 'preparing'
    ? (countdown ? `Getting your clip ready — ${countdown}` : 'Getting your clip ready')
    : phase === 'posting' ? 'Posting your clip'
    : phase === 'done' ? 'Your clip is up'
    : error

  return (
    <div className={`clipbar${phase === 'failed' ? ' bad' : ''}`}>
      {poster
        ? <img className="clipbar-thumb" src={poster} alt="" />
        : <span className="clipbar-thumb is-blank" />}

      <div className="clipbar-body">
        <div className="clipbar-title">{title}</div>
        <div className="clipbar-line">{line}</div>
        {phase !== 'done' && phase !== 'failed' && (
          <div className="clipbar-track"><i style={{ width: `${overall}%` }} /></div>
        )}
      </div>

      {phase === 'preparing' || phase === 'posting' ? (
        <button className="clipbar-act" onClick={cancel}>Cancel</button>
      ) : phase === 'done' ? (
        <button className="clipbar-act" onClick={() => { dismiss(); nav('/collective') }}>
          See it
        </button>
      ) : (
        <button className="clipbar-act" onClick={dismiss}>Close</button>
      )}
    </div>
  )
}
